import React from 'react';
import './ContactSection.css';
import urls from '../config/urls';
import contactData from '../data/contact.json';

const ContactSection = () => {
  const { contact } = contactData;

  const renderIcon = (iconType) => {
    const icons = {
      email: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2" fill="none"/>
          <polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="2"/>
        </svg>
      ),
      phone: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" stroke="currentColor" strokeWidth="2" fill="none"/>
        </svg>
      ),
      clock: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
          <polyline points="12,6 12,12 16,14" stroke="currentColor" strokeWidth="2"/>
        </svg>
      ),
      platform: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M10 1L4 7v10c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7l-6-6z" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <polyline points="8,9 12,9" stroke="currentColor" strokeWidth="1.5"/>
          <polyline points="10,7 10,13" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      )
    };
    return icons[iconType] || icons.email;
  };

  const getContactValue = (item) => {
    switch (item.id) {
      case 'email':
        return urls.contact.email;
      case 'phone':
        return urls.contact.phone;
      case 'schedule':
        return urls.contact.schedule;
      default:
        return item.value;
    }
  };

  const getContactLink = (item) => {
    const value = getContactValue(item);
    switch (item.type) {
      case 'email':
        return `mailto:${value}`;
      case 'phone':
        return `tel:${value}`;
      default:
        return null;
    }
  };

  const handleButtonAction = (button) => {
    switch (button.action) {
      case 'email':
        window.location.href = `mailto:${urls.contact.email}`;
        break;
      case 'platform':
        window.open(urls.app, '_blank');
        break;
      default:
        break;
    }
  };
  return (
    <section id="contacto" className="contact-section">
      <div className="container">
        <div className="contact-header">
          <div className="section-badge">
            <span className="badge-icon">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M2 3l6.5 4L15 3v10a1 1 0 01-1 1H2a1 1 0 01-1-1V3z" stroke="currentColor" strokeWidth="1.5" fill="none"/>
                <path d="M15 3L8.5 7 2 3l12 0z" stroke="currentColor" strokeWidth="1.5" fill="none"/>
              </svg>
            </span>
            {contact.header.badge}
          </div>
          <h2 className="section-title">{contact.header.title.split(' ').slice(0, 2).join(' ')} <span className="gradient-text">{contact.header.title.split(' ').slice(2).join(' ')}</span></h2>
          <p className="section-subtitle">
            {contact.header.subtitle}
          </p>
        </div>
        
        <div className="contact-content">
          <div className="contact-info glass-card">
            {contact.contactInfo.map((item, index) => {
              const value = getContactValue(item);
              const link = getContactLink(item);
              
              return (
                <div key={index} className="contact-item">
                  <div className="contact-icon">
                    {renderIcon(item.icon)}
                  </div>
                  <div className="contact-details">
                    <h3>{item.title}</h3>
                    {link ? (
                      <p><a href={link}>{value}</a></p>
                    ) : (
                      <p>{value.split('\n').map((line, i) => (
                        <React.Fragment key={i}>
                          {line}
                          {i < value.split('\n').length - 1 && <br />}
                        </React.Fragment>
                      ))}</p>
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          <div className="contact-form-card glass-card">
            <h3>{contact.form.title}</h3>
            <div className="coming-soon-message">
              <div className="coming-soon-icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                  <circle cx="24" cy="24" r="20" stroke="currentColor" strokeWidth="2" fill="none"/>
                  <path d="M16 24l6 6 12-12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <p>
                {contact.form.comingSoon.message}
              </p>
              <div className="cta-buttons">
                {contact.form.comingSoon.buttons.map((button, index) => (
                  <button
                    key={index}
                    onClick={() => handleButtonAction(button)}
                    className={`btn glass-btn ${button.type}`}
                  >
                    {renderIcon(button.icon)}
                    {button.text}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
